import { commonUtils } from './common_utils';
import './native_share';

export const adReview = {
    loadArticleTimeout: 1000,
    showHideComment(reviewId) {
        let showCaption = $(`#showLess${reviewId}`).is(':visible')
            ? Translations.ad_review.show_less
            : Translations.ad_review.read_more;
        $(`#showLess${reviewId}, #showMore${reviewId}`).toggle();
        $(`#showHideCommentId${reviewId}`).html(`${showCaption} &#187;`);
        return false;
    },
    loadMoreVehicleModels() {
        let pageNo = $('.loadMoreData').data('page-no');
        let params = `${$('#formSortingCategory').find('input, select').serialize()}&page=${pageNo}`;
        $.get(Routing.generate('vehicle_model_list'), params, function (data) {
            $('#vehicleModelList').append(data);
            $(`#loadMoreData_${pageNo}`).remove();
        });
    },
    loadMoreModelReviews() {
        let $getReviewData = $('#getReviewData');
        let makeId = $getReviewData.data('make-id') || 0;
        let modelId = $getReviewData.data('model-id') || 0;
        let pageNo = $('.loadMoreData').data('page-no');
        let params = `${$('#formReviewSearch').find('input, select').serialize()}&page=${pageNo}&id_make=${makeId}&id_model=${modelId}`;
        if (makeId > 0 && modelId > 0) {
            $.get(Routing.generate('review_list'), params, function (data) {
                $('#modelReviewList').append(data);
                $(`#loadMoreData_${pageNo}`).remove();
            });
        }
    },
    getModelList(routeName, idMake, fieldId, idModel = 0) {
        let params = `id_make=${idMake}`;
        $.get(Routing.generate(routeName), params, function (response) {
            if (response) {
                let $fieldId = $(`#${fieldId}`);
                $fieldId.html(response.model_html).prop('disabled', false);

                if (idModel > 0) {
                    $fieldId.val(idModel);
                }
            }
        });
    },
    createReviewModal() {
        if (!commonUtils.isUserLogin()) {
            almaTunnusLogin.init($(this).data('usl-source'), false, window.location.href);
        } else if (commonUtils.isDealerLogin()) {
            alert(Translations.review_not_for_dealer_text);
        } else {
            let $make = $('#reviewMakeModal');
            let $model = $('#reviewModelModal');
            let $getReviewData = $('#getReviewData');
            let makeId = $getReviewData.data('make-id') || 0;
            let modelId = $getReviewData.data('model-id') || 0;

            $.colorbox({ inline: true, href: '#createReviewModal' });

            if (makeId > 0) {
                $make.val(makeId);
                $model.prop('disabled', true);
                if (modelId > 0) {
                    adReview.getModelList('options_get_model_by_make', makeId, 'reviewModelModal', modelId);
                } else {
                    adReview.getModelList('options_get_model_by_make', makeId, 'reviewModelModal');
                }
            }
        }
    },
    searchByMakeModel() {
        let $reviewMake = $('#searchByMake');
        let makeId = parseInt($reviewMake.val(), 10);
        let modelId = $('#searchByModel').val();
        let searchMakeId = parseInt($('#formSortingCategory').find('input[name="searchByMake"]').val(), 10) || null;

        if (makeId > 0 && (makeId !== searchMakeId || modelId > 0)) {
            let makeName = commonUtils.formatUri($('#searchByMake option:selected').text());
            let modelName =
                modelId > 0 ? commonUtils.formatUri($.trim($('#searchByModel option:selected').text())) : '';
            if (modelName !== '') {
                location.href = Routing.generate('list_make_model_review', {
                    make: makeName,
                    model: modelName,
                });
            } else {
                location.href = Routing.generate('list_make_review', { make: makeName });
            }
        } else {
            $('#searchReviewByEntity').submit();
        }
    },
    redirectReviewListing(makeName, modelName) {
        if (makeName !== '' && modelName === '') {
            location.href = Routing.generate('list_make_review', { make: makeName });
        } else if (makeName !== '' && modelName !== '') {
            location.href = Routing.generate('list_make_model_review', { make: makeName, model: modelName });
        }
    },
    getArticleList(_currentPage) {
        let loadOnce = false;
        let $getReviewData = $('#getReviewData');
        let makeId = $getReviewData.data('make-id');
        let modelId = $getReviewData.data('model-id');
        let topSectionPosition = $('.topSectionPosition').offset().top;

        $(window).scroll(function () {
            if ($(window).scrollTop() + $(window).height() > topSectionPosition && !loadOnce) {
                loadOnce = true;
                let params = `id_make=${makeId}`;
                if (modelId > 0) {
                    params += `&id_model=${modelId}`;
                }

                $.get(Routing.generate('review_articles'), params, function (response) {
                    if (response.bottom_articles) {
                        $('#articleList').show();
                        $('#bottomArticles').append(response.bottom_articles);
                    }
                });
            }
        });
    },
    showCircleBar() {
        let $getReviewData = $('#getReviewData');
        $('#circle').progressCircle({
            nPercent: $getReviewData.data('buy-again-percentage'),
            thickness: 14,
            circleSize: 66,
            showPercentText: false,
            barOverride: false,
        });
    },
    saveUserOpinionOnReviewComment($saveReviewLike) {
        let reviewId = $saveReviewLike.data('reviewid');
        let params = `review_id=${reviewId}`;
        $(`#reviewLikeYes${reviewId}, #reviewLikeNo${reviewId}`).remove();
        if ($saveReviewLike.data('like')) {
            $.post(Routing.generate('review_process_like'), params, function (response) {
                if (response.status) {
                    $(`#show_success_message_${reviewId}`).html(Translations.ad_review.thanks_for_feedback);
                }
            });
        }
    },
    startReview() {
        let $make = $('#reviewMakeModal');
        let $model = $('#reviewModelModal');

        if ($make.val() === '') {
            alert(Translations.ad_review.error_message.select_make);
            return false;
        }
        if ($model.val() === '') {
            alert(Translations.ad_review.error_message.select_model);
            return false;
        }

        let reviewMake = $make.find('option:selected').text();
        let reviewModel = $model.find('option:selected').text();

        let params = {
            make: commonUtils.formatUri(reviewMake.toLowerCase()),
            model: commonUtils.formatUri(reviewModel.toLowerCase()),
        };

        location.href = Routing.generate('post_review', params);
        return undefined;
    },
};
